import React, { FC, SyntheticEvent } from 'react';

import trackListingPhotoClick from 'src/common/utils/trackListingPhotoClick';
import styles from './PhotosGrid.module.scss';
import Img from '../Img';

export type PhotosGridProps = {
  listingId: string;
  photos: { src: string; alt: string }[];
  openPhoto: (event: SyntheticEvent, index: number) => void;
};

const PhotosGrid: FC<PhotosGridProps> = ({
  photos,
  openPhoto,
  listingId,
}) => photos.length > 0 && (
  <ol className={styles.root}>
    {photos.map(({ alt, src }, index) => (
      <li
        key={src}
        className={styles.item}
      >
        <a
          href={src}
          onClick={(event) => {
            event.preventDefault();
            openPhoto(event, index);
            trackListingPhotoClick({
              index,
              imageLocation: 'review',
              listingId,
              totalPhotos: photos.length,
            });
          }}
        >
          <Img
            src={src}
            imageParams={{
              w: 172,
            }}
            alt={alt}
            className={styles.image}
            width={172}
            height={103}
          />
        </a>
      </li>
    ))}
  </ol>
);

export default PhotosGrid;
